import Alert from 'flarum/common/components/Alert';

const knownCodes = new Set([
    'wrong_num',
    'code_exist',
    'code_null',
    'code_expired',
    'code_invalid',
    'phone_exist',
    'sms_service_unavailable',
    'sms_rate_limited',
    'sms_daily_limit',
    'region_invalid',
    'param_invalid',
]);

function errorCode(error) {
    if (typeof error === 'string') return error;

    const firstError = error?.response?.errors?.[0] || error?.errors?.[0] || {};
    return firstError.detail || firstError.code || error?.detail || error?.code || error?.message || '';
}

export function showPhoneError(error, parameters = {}) {
    const code = errorCode(error);
    const message = knownCodes.has(code)
        ? app.translator.trans(`lakevy-phone-binding.forum.alerts.${code}`, parameters)
        : app.translator.trans('lakevy-phone-binding.forum.alerts.operation_failed');

    app.alerts.show(Alert, { type: 'error' }, message);
}

export function showPhoneSuccess(key) {
    app.alerts.show(Alert, { type: 'success' }, app.translator.trans(`lakevy-phone-binding.forum.alerts.${key}`));
}
